var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosedBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "418px",
    height: "279px",
    viewBox: "0 0 418 279",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Closed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-24.3%",
    y: "-91.7%",
    width: "148.6%",
    height: "283.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.14620536,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "0.542808043 0.577152046 5.93568047 0.577152046 5.93568047 5.97067247 0.542808043 5.97067247"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "0.542808043 0.577152046 5.93568047 0.577152046 5.93568047 5.97067247 0.542808043 5.97067247"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-6",
    points: "0 0.730406714 35.5171277 0.730406714 35.5171277 12.3370099 0 12.3370099"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-8",
    points: "0 0.38620383 35.5171277 0.38620383 35.5171277 9.21972009 0 9.21972009"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VB--Start-Copy-6",
    transform: "translate(-522.000000, -250.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "closed-background",
    transform: "translate(521.000000, 250.788095)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "lock-shadow-copy",
    fill: "#EBEBEB",
    filter: "url(#filter-1)",
    cx: 207.614819,
    cy: 260.991394,
    rx: 25.6114026,
    ry: 6.77948893
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.6720877,125.78797 C87.6720877,122.80933 85.2572075,120.394449 82.2785672,120.394449 C79.299927,120.394449 76.8850468,122.80933 76.8850468,125.78797 C76.8850468,128.76661 79.299927,131.18149 82.2785672,131.18149 C85.2572075,131.18149 87.6720877,128.76661 87.6720877,125.78797",
    id: "Fill-1-Copy-2",
    fill: "#528AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0783733,35.9672429 C39.0783733,32.9886026 36.6634931,30.5737224 33.6848529,30.5737224 C30.7062126,30.5737224 28.2913324,32.9886026 28.2913324,35.9672429 C28.2913324,38.9458831 30.7062126,41.3607633 33.6848529,41.3607633 C36.6634931,41.3607633 39.0783733,38.9458831 39.0783733,35.9672429",
    id: "Fill-1-Copy-3",
    fill: "#528AE8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-2",
    transform: "translate(78.671224, 21.755522)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93632847,3.27283226 C5.93632847,1.78459214 4.72888838,0.577152046 3.24064826,0.577152046 C1.75240814,0.577152046 0.542808043,1.78459214 0.542808043,3.27283226 C0.542808043,4.76107238 1.75240814,5.97067247 3.24064826,5.97067247 C4.72888838,5.97067247 5.93632847,4.76107238 5.93632847,3.27283226",
    id: "Fill-3",
    fill: "#30AADE",
    mask: "url(#mask-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-3",
    transform: "translate(0.721090, 212.004511)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93632847,3.27283226 C5.93632847,1.78459214 4.72888838,0.577152046 3.24064826,0.577152046 C1.75240814,0.577152046 0.542808043,1.78459214 0.542808043,3.27283226 C0.542808043,4.76107238 1.75240814,5.97067247 3.24064826,5.97067247 C4.72888838,5.97067247 5.93632847,4.76107238 5.93632847,3.27283226",
    id: "Fill-3",
    fill: "#30AADE",
    mask: "url(#mask-5)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.943083,44.3596443 C172.943083,42.1262041 171.130843,40.316124 168.897403,40.316124 C166.663963,40.316124 164.853883,42.1262041 164.853883,44.3596443 C164.853883,46.5930845 166.663963,48.4053246 168.897403,48.4053246 C171.130843,48.4053246 172.943083,46.5930845 172.943083,44.3596443",
    id: "Fill-6-Copy-2",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.332293,69.2679655 C304.332293,67.0345253 302.520053,65.2244452 300.286613,65.2244452 C298.053173,65.2244452 296.243093,67.0345253 296.243093,69.2679655 C296.243093,71.5014057 298.053173,73.3136458 300.286613,73.3136458 C302.520053,73.3136458 304.332293,71.5014057 304.332293,69.2679655",
    id: "Fill-6-Copy-3",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6838118,147.980237 C20.6838118,145.746797 18.8737317,143.934557 16.6402915,143.934557 C14.4068513,143.934557 12.5946112,145.746797 12.5946112,147.980237 C12.5946112,150.213678 14.4068513,152.023758 16.6402915,152.023758 C18.8737317,152.023758 20.6838118,150.213678 20.6838118,147.980237",
    id: "Fill-8-Copy-2",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.243093,35.9683229 C296.243093,33.7348827 294.433013,31.9226425 292.199572,31.9226425 C289.966132,31.9226425 288.153892,33.7348827 288.153892,35.9683229 C288.153892,38.201763 289.966132,40.0118432 292.199572,40.0118432 C294.433013,40.0118432 296.243093,38.201763 296.243093,35.9683229",
    id: "Fill-8-Copy-3",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.158052,54.3596443 C109.158052,52.8714042 107.950612,51.6639641 106.462372,51.6639641 C104.974132,51.6639641 103.764532,52.8714042 103.764532,54.3596443 C103.764532,55.8478844 104.974132,57.0574845 106.462372,57.0574845 C107.950612,57.0574845 109.158052,55.8478844 109.158052,54.3596443",
    id: "Fill-10-Copy-2",
    fill: "#4AD1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.892504,209.306671 C412.892504,207.818431 411.685063,206.610991 410.196823,206.610991 C408.708583,206.610991 407.498983,207.818431 407.498983,209.306671 C407.498983,210.794911 408.708583,212.004511 410.196823,212.004511 C411.685063,212.004511 412.892504,210.794911 412.892504,209.306671",
    id: "Fill-10-Copy-3",
    fill: "#4AD1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.764532,174.8915 C103.764532,173.403259 102.554932,172.193659 101.066691,172.193659 C99.5784513,172.193659 98.3710112,173.403259 98.3710112,174.8915 C98.3710112,176.37974 99.5784513,177.58718 101.066691,177.58718 C102.554932,177.58718 103.764532,176.37974 103.764532,174.8915",
    id: "Fill-12-Copy",
    fill: "#4AD1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6712244,248.105723 C78.6712244,246.617483 77.4637843,245.410043 75.9733842,245.410043 C74.485144,245.410043 73.2777039,246.617483 73.2777039,248.105723 C73.2777039,249.593963 74.485144,250.803563 75.9733842,250.803563 C77.4637843,250.803563 78.6712244,249.593963 78.6712244,248.105723",
    id: "Fill-14-Copy-3",
    fill: "#528AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.735929,90.1275453 C372.735929,88.6393052 371.528488,87.4318651 370.038088,87.4318651 C368.549848,87.4318651 367.342408,88.6393052 367.342408,90.1275453 C367.342408,91.6157854 368.549848,92.8253855 370.038088,92.8253855 C371.528488,92.8253855 372.735929,91.6157854 372.735929,90.1275453",
    id: "Fill-14-Copy-4",
    fill: "#528AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.735929,137.978077 C372.735929,136.489837 371.528488,135.282397 370.038088,135.282397 C368.549848,135.282397 367.342408,136.489837 367.342408,137.978077 C367.342408,139.466318 368.549848,140.675918 370.038088,140.675918 C371.528488,140.675918 372.735929,139.466318 372.735929,137.978077",
    id: "Fill-14-Copy-5",
    fill: "#528AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.321281,149.91064 C331.321281,148.02712 329.79416,146.5 327.91064,146.5 C326.02712,146.5 324.5,148.02712 324.5,149.91064 C324.5,151.79416 326.02712,153.319121 327.91064,153.319121 C329.79416,153.319121 331.321281,151.79416 331.321281,149.91064",
    id: "Fill-16-Copy-3",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.875169,61.8159649 C238.875169,59.9324448 237.348049,58.4053246 235.464529,58.4053246 C233.581009,58.4053246 232.053889,59.9324448 232.053889,61.8159649 C232.053889,63.6994851 233.581009,65.2244452 235.464529,65.2244452 C237.348049,65.2244452 238.875169,63.6994851 238.875169,61.8159649",
    id: "Fill-16-Copy-4",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.069867,242.001563 C363.069867,240.118042 361.542747,238.590922 359.659227,238.590922 C357.775707,238.590922 356.248586,240.118042 356.248586,242.001563 C356.248586,243.885083 357.775707,245.410043 359.659227,245.410043 C361.542747,245.410043 363.069867,243.885083 363.069867,242.001563",
    id: "Fill-16-Copy-5",
    fill: "#30AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.286024,128.48365 C418.286024,126.99541 417.076424,125.78797 415.588184,125.78797 C414.099944,125.78797 412.892504,126.99541 412.892504,128.48365 C412.892504,129.97405 414.099944,131.18149 415.588184,131.18149 C417.076424,131.18149 418.286024,129.97405 418.286024,128.48365",
    id: "Fill-18-Copy-2",
    fill: "#4AD1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.474627,2.69568021 C213.474627,1.2074401 212.265027,0 210.776787,0 C209.288547,0 208.081107,1.2074401 208.081107,2.69568021 C208.081107,4.18608033 209.288547,5.39352043 210.776787,5.39352043 C212.265027,5.39352043 213.474627,4.18608033 213.474627,2.69568021",
    id: "Fill-18-Copy-3",
    fill: "#4AD1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.641066,193.87952 C348.641066,191.77784 346.936826,190.07576 344.835146,190.07576 C342.737785,190.07576 341.033545,191.77784 341.033545,193.87952 C341.033545,195.9812 342.737785,197.68328 344.835146,197.68328 C346.936826,197.68328 348.641066,195.9812 348.641066,193.87952",
    id: "Fill-20-Copy-3",
    fill: "#FDD972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.248586,43.8156035 C356.248586,41.7139233 354.544346,40.0118432 352.442666,40.0118432 C350.345306,40.0118432 348.641066,41.7139233 348.641066,43.8156035 C348.641066,45.9172836 350.345306,47.6193638 352.442666,47.6193638 C354.544346,47.6193638 356.248586,45.9172836 356.248586,43.8156035",
    id: "Fill-20-Copy-4",
    fill: "#FDD972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2913324,89.0216252 C28.2913324,86.919945 26.5870923,85.2178649 24.4854121,85.2178649 C22.388052,85.2178649 20.6838118,86.919945 20.6838118,89.0216252 C20.6838118,91.1233054 22.388052,92.8253855 24.4854121,92.8253855 C26.5870923,92.8253855 28.2913324,91.1233054 28.2913324,89.0216252",
    id: "Fill-20-Copy-5",
    fill: "#FDD972"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stanchions",
    transform: "translate(116.597015, 89.991394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.45646754,35.1715931 L3.38630075,35.1449583 C3.38630075,31.2071134 10.836859,29.4143901 17.7598444,29.4143901 C24.6818053,29.4143901 32.1313392,31.2071134 32.1313392,35.1449583 L29.0580991,35.1449583 C29.0580991,35.1582757 29.060148,35.1685198 29.0611724,35.1715931 C28.8450212,34.4319666 25.0434232,32.4876301 17.7598444,32.4876301 C10.4762655,32.4876301 6.67261875,34.4319666 6.45646754,35.1715931",
    id: "Fill-5",
    fill: "#E09128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.703997,35.1715931 L153.63383,35.1449583 C153.63383,31.2071134 161.084388,29.4143901 168.007374,29.4143901 C174.929335,29.4143901 182.378869,31.2071134 182.378869,35.1449583 L179.305628,35.1449583 C179.305628,35.1582757 179.307677,35.1685198 179.308702,35.1715931 C179.092551,34.4319666 175.290953,32.4876301 168.007374,32.4876301 C160.724819,32.4876301 156.920148,34.4319666 156.703997,35.1715931",
    id: "Fill-7",
    fill: "#E09128"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 160.505083)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7599468,0.730406714 C7.95221346,0.730406714 -0.000307324003,3.32729454 -0.000307324003,6.53268389 C-0.000307324003,9.73909765 7.95221346,12.3370099 17.7599468,12.3370099 C27.5707534,12.3370099 35.5171277,9.73909765 35.5171277,6.53268389 C35.5171277,3.32729454 27.5707534,0.730406714 17.7599468,0.730406714",
    id: "Fill-9",
    fill: "#E09128",
    mask: "url(#mask-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 166.651563)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7599468,6.19052983 C7.95221346,6.19052983 -0.000307324003,3.59261759 -0.000307324003,0.38620383 L-0.000307324003,3.41744291 C-0.000307324003,6.62283226 7.95221346,9.21972009 17.7599468,9.21972009 C27.5707534,9.21972009 35.5171277,6.62283226 35.5171277,3.41744291 L35.5171277,0.38620383 C35.5171277,3.59261759 27.5707534,6.19052983 17.7599468,6.19052983",
    id: "Fill-12",
    fill: "#F4B925",
    mask: "url(#mask-9)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.7599468,160.164055 C10.6699821,160.164055 4.9230232,162.040781 4.9230232,164.358004 C4.9230232,166.674202 10.6699821,168.554001 17.7599468,168.554001 C24.850936,168.554001 30.5948216,166.674202 30.5948216,164.358004 C30.5948216,162.040781 24.850936,160.164055 17.7599468,160.164055",
    id: "Fill-15",
    fill: "#E09128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7599468,168.55441 C10.6699821,168.55441 4.9230232,166.674612 4.9230232,164.357389 L4.9230232,166.549634 C4.9230232,168.866857 10.6699821,170.743582 17.7599468,170.743582 C24.850936,170.743582 30.5948216,168.866857 30.5948216,166.549634 L30.5948216,164.357389 C30.5948216,166.674612 24.850936,168.55441 17.7599468,168.55441",
    id: "Fill-17",
    fill: "#F4B925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6369581,22.1193378 L12.6369581,165.096708 C12.6369581,166.022778 14.9295952,166.771624 17.7590248,166.771624 C20.5894789,166.771624 22.8810916,166.022778 22.8810916,165.096708 L22.8810916,22.1193378 L12.6369581,22.1193378 Z",
    id: "Fill-19",
    fill: "#F4B925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6369581,30.4466914 C14.2268476,31.0644127 15.9499109,31.4157864 17.7590248,31.4157864 C19.5681388,31.4157864 21.2901776,31.0644127 22.8810916,30.4466914 L22.8810916,22.1192353 L12.6369581,22.1192353 L12.6369581,30.4466914 Z",
    id: "Fill-21",
    fill: "#B56D18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58729065,14.1730659 C3.58729065,6.34449916 9.93148248,0.000307324003 17.7590248,0.000307324003 C25.5855428,0.000307324003 31.9297346,6.34449916 31.9297346,14.1730659 C31.9297346,21.9985595 25.5855428,28.3427513 17.7590248,28.3427513 C9.93148248,28.3427513 3.58729065,21.9985595 3.58729065,14.1730659",
    id: "Fill-23",
    fill: "#F4B925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27528112,16.2529323 C7.27528112,9.51741461 12.7343798,4.0583159 19.4698976,4.0583159",
    id: "Stroke-25",
    stroke: "#FFDD99",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.007579,161.235489 C158.199845,161.235489 150.247324,163.832377 150.247324,167.037766 C150.247324,170.24418 158.199845,172.842092 168.007579,172.842092 C177.817361,172.842092 185.764759,170.24418 185.764759,167.037766 C185.764759,163.832377 177.817361,161.235489 168.007579,161.235489",
    id: "Fill-27",
    fill: "#E09128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.007579,172.842092 C158.199845,172.842092 150.247324,170.24418 150.247324,167.037766 L150.247324,170.069006 C150.247324,173.274395 158.199845,175.871283 168.007579,175.871283 C177.817361,175.871283 185.764759,173.274395 185.764759,170.069006 L185.764759,167.037766 C185.764759,170.24418 177.817361,172.842092 168.007579,172.842092",
    id: "Fill-29",
    fill: "#F4B925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.007579,160.164055 C160.917614,160.164055 155.170655,162.040781 155.170655,164.358004 C155.170655,166.674202 160.917614,168.554001 168.007579,168.554001 C175.098568,168.554001 180.842453,166.674202 180.842453,164.358004 C180.842453,162.040781 175.098568,160.164055 168.007579,160.164055",
    id: "Fill-31",
    fill: "#E09128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.007579,168.55441 C160.917614,168.55441 155.170655,166.674612 155.170655,164.357389 L155.170655,166.549634 C155.170655,168.866857 160.917614,170.743582 168.007579,170.743582 C175.098568,170.743582 180.842453,168.866857 180.842453,166.549634 L180.842453,164.357389 C180.842453,166.674612 175.098568,168.55441 168.007579,168.55441",
    id: "Fill-33",
    fill: "#F4B925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.883566,22.1193378 L162.883566,165.096708 C162.883566,166.022778 165.177227,166.771624 168.006657,166.771624 C170.837111,166.771624 173.127699,166.022778 173.127699,165.096708 L173.127699,22.1193378 L162.883566,22.1193378 Z",
    id: "Fill-35",
    fill: "#F4B925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.883566,30.4466914 C164.474479,31.0644127 166.196518,31.4157864 168.005632,31.4157864 C169.814746,31.4157864 171.537809,31.0644127 173.127699,30.4466914 L173.127699,22.1192353 L162.883566,22.1192353 L162.883566,30.4466914 Z",
    id: "Fill-37",
    fill: "#B56D18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.834922,14.1730659 C153.834922,6.34449916 160.179114,0.000307324003 168.005632,0.000307324003 C175.833175,0.000307324003 182.177366,6.34449916 182.177366,14.1730659 C182.177366,21.9985595 175.833175,28.3427513 168.005632,28.3427513 C160.179114,28.3427513 153.834922,21.9985595 153.834922,14.1730659",
    id: "Fill-39",
    fill: "#F4B925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8823285,61.3271194 C62.9008232,61.3271194 47.2313967,38.3607967 37.794501,33.0983854 L32.00759,41.962634 C41.8767882,47.5969074 59.5458695,71.8662839 92.8823285,71.8662839 C126.217763,71.8662839 143.884796,47.5989562 153.756043,41.9636584 L147.973229,33.0963365 C138.539407,38.3577235 122.867931,61.3271194 92.8823285,61.3271194",
    id: "Fill-41",
    fill: "#9E281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9855273,30.8598373 C31.548448,29.2689234 28.2826182,29.9542559 26.6917043,32.3923597 C25.1007904,34.829439 25.7871473,38.0952688 28.2242267,39.6851583 C28.4762323,39.8500888 29.7905547,40.6972786 32.0073851,41.9624291 L37.7942961,33.0992049 C35.4330234,31.7818093 34.0879686,30.9253998 33.9855273,30.8598373",
    id: "Fill-43",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.072953,32.3985062 C157.486136,29.9614268 154.221331,29.2709722 151.783227,30.8567641 C151.719714,30.898765 150.369537,31.7613211 147.973434,33.0971561 L153.756248,41.9634535 C155.973078,40.6972786 157.288425,39.8500888 157.54043,39.6851583 C159.975461,38.0962932 160.660793,34.8345611 159.072953,32.3985062",
    id: "Fill-45",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.453953,
    y1: 34.0661486,
    x2: 166.453953,
    y2: 161.707027,
    id: "Stroke-47",
    stroke: "#FFDD99",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.007579,40.8778827 C161.084593,40.8778827 153.634035,39.084135 153.634035,35.1442412 C153.634035,34.296027 154.322441,33.6076212 155.170655,33.6076212 C156.012723,33.6076212 156.697031,34.2857829 156.707275,35.1268262 C156.95211,35.8736235 160.753708,37.8046427 168.007579,37.8046427 C175.291157,37.8046427 179.092755,35.8582573 179.308907,35.1176065 C179.308907,34.2693922 179.995264,33.5953283 180.843478,33.5953283 C181.692716,33.5953283 182.379073,34.296027 182.379073,35.1442412 C182.379073,39.084135 174.92954,40.8778827 168.007579,40.8778827",
    id: "Fill-49",
    fill: "#F4B925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.786565,16.2529323 C156.786565,9.51741461 162.245663,4.0583159 168.981181,4.0583159",
    id: "Stroke-51",
    stroke: "#FFDD99",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.674651,
    y1: 34.0661486,
    x2: 15.674651,
    y2: 161.707027,
    id: "Stroke-53",
    stroke: "#FFDD99",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7599468,40.8778827 C10.8369614,40.8778827 3.38640319,39.084135 3.38640319,35.1442412 C3.38640319,34.296027 4.07378454,33.6076212 4.9230232,33.6076212 C5.76509097,33.6076212 6.44939908,34.2857829 6.45964322,35.1268262 C6.70447801,35.8736235 10.5060759,37.8046427 17.7599468,37.8046427 C25.0435257,37.8046427 28.8451236,35.8582573 29.0612748,35.1176065 C29.0612748,34.2693922 29.7476317,33.5953283 30.595846,33.5953283 C31.4450847,33.5953283 32.1314416,34.296027 32.1314416,35.1442412 C32.1314416,39.084135 24.6819078,40.8778827 17.7599468,40.8778827",
    id: "Fill-55",
    fill: "#F4B925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3019282,61.2601228 C93.3019282,61.2601228 87.1943759,64.4368286 88.2720587,71.8668986",
    id: "Stroke-93",
    stroke: "#DDDDDD"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedBackground);
export default __webpack_public_path__ + "static/media/closed-background.0e9130a5f56b852bfe999965ae0cc87b.svg";
export { ForwardRef as ReactComponent };